import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {TemplateService} from '../../services/template.service';
import {CALENDAR_LOCALE} from '../../services/constant';
import {ApiService} from '../../services/api.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {SelectItem} from 'primeng/api';
import * as _ from 'lodash';
import {HttpParams} from '@angular/common/http';
import {Subscription} from "rxjs";
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-history-log',
  templateUrl: './history-log.component.html',
  styleUrls: ['./history-log.component.scss'],
  providers: [TemplateService]
})
export class HistoryLogComponent implements OnInit, OnDestroy {

  startDate: Date = new Date(moment().format('YYYY') + '-01-01');
  endDate: Date = new Date(moment().format('YYYY') + '-12-30');
  maxDate: Date;
  minDate: Date;
  loading = false;
  calendarLocale = CALENDAR_LOCALE.TH;
  currentPage: 1;
  itemsPerPage: number;
  totalItems: number;
  errors = [];
  selectedCustomercode = null;
  selectedRdDocumentType: any;
  checkdate = null;
  rdDocumentType: any;
  defaultLabel = null;
  sortBy = null;
  sortMode = null;
  no_data = true;
  errorMsg = '';
  deliverycode: any;
  documentType: any;
  notApprove: any;
  selectedHomeproGroup: SelectItem[];
  selectedDeliverycode: SelectItem[];
  tableData: any;
  tempTableData: any;
  allDeliverycode = true;
  allDocType = true;
  selectedValues = [];
  allSniffs: any;
  usernames: any = [];
  searchUsername: '';
  roles: any = [];
  searchRole: '';
  actions: any;
  searchAction: '';
  tableCol = [];
  loading_excel_report = false;
  subs: Subscription;

  @ViewChild('content') content: any;
  @ViewChild('tt') table: any;

  constructor(
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private apiService: ApiService,
    private template: TemplateService,
    private translate: TranslateService
  ) {
    this.currentPage = 1;
    this.itemsPerPage = 40;
    this.totalItems = 0;
  }

  ngOnInit() {
    this.clearSearch();
    this.searchButtonClicked();

    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.clearSearch();
      this.searchButtonClicked();
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = '';
    } else {
      this.sortMode = '-';
    }
  }

  clearSearch() {
    this.searchUsername = '';
    this.searchRole = '';
    this.searchAction = '';
    this.loadSearch();
  }

  loadSearch() {
    this.loadUsers();
    this.loadRoles();
    this.loadActions();
    this.loadDates();
    this.tableCol = [];
    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      this.tableCol.push(
        {field: 'created_at', header: this.translate.instant('HISTORY.DATE')},
        {field: 'role', header: this.translate.instant('HISTORY.ROLE')},
        {field: 'actor', header: this.translate.instant('HISTORY.USERNAME')},
        {field: 'action', header: this.translate.instant('HISTORY.ACTION')},
        {field: 'address', header: this.translate.instant('HISTORY.ADDRESS')},
      );
      this.tableCol = _.uniqBy(this.tableCol, 'field');
    });
    this.currentPage = 1;
  }

  loadUsers() {
    this.usernames = [];
    this.usernames = [{
      'label': this.translate.instant('COMMON.ALL'),
      'value': ''
    }];
    this.loading = true;
    this.apiService.getUsers().subscribe(
      (users) => {
        _.forEach(users, (user) => {
          this.usernames.push({
            'label': user.username,
            'value': user.id
          });
        });
        this.loading = false;
        this.usernames = _.uniqBy(this.usernames, 'label');
      },
      error => {
        this.loading = false;
        console.log('error', error);
      }
    );
  }

  loadRoles() {
    this.roles = [];
    this.roles = [{
      'label': this.translate.instant('COMMON.ALL'),
      'value': ''
    }];
    this.loading = true;
    let params = {}
    if (!this.authenticationService.isAdmin()) {
      params = {source: 'action-logs'}
    }

    this.apiService.getRoles(params).subscribe(
      (roles) => {
        _.forEach(roles, (role) => {
          this.roles.push({
            'label': role.name,
            'value': role.id
          });
        });
        this.loading = false;
        this.roles = _.uniqBy(this.roles, 'label');
      },
      error => {
        this.loading = false;
        console.log('error', error);
      }
    );
  }

  loadActions() {
    this.actions = [];
    this.actions = [{
      'label': this.translate.instant('COMMON.ALL'),
      'value': ''
    }];
    this.loading = true;
    this.apiService.getActions().subscribe(
      (actions) => {
        _.forEach(actions.results, (action) => {
          this.actions.push({
            'label': this.translate.instant('HISTORY.ACTION-ENUM.' + action.name),
            'value': action.name
          });
        });
        this.loading = false;
        this.actions = _.uniqBy(this.actions, 'label');
      },
      error => {
        this.loading = false;
        console.log('error', error);
      }
    );
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  loadDates() {

    this.defaultLabel = this.translate.instant('COMMON.ALL');
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.defaultLabel = this.translate.instant('COMMON.ALL');
    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();
  }

  sentDate() {
    this.checkdate = 1;
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.searchData();
  }

  searchData(params?) {

    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }
    const data = {
      page: this.currentPage,
      items_per_page: this.itemsPerPage,
      actor_id: this.searchUsername,
      role_id: this.searchRole,
      action: this.searchAction,
      start_date: moment(this.startDate).format('YYYY-MM-DD'),
      end_date: moment(this.endDate).format('YYYY-MM-DD')
    };

    if (this.sortBy) {
      if (this.sortBy === 'action') {
        data['ordering'] = this.sortMode + this.sortBy + ',' + this.sortMode + 'target';
      } else {
        data['ordering'] = this.sortMode + this.sortBy;
      }
    }

    if (this.currentPage === 1) {
      params = null;
    }
    this.apiService.getSniffs(data).subscribe(
      (result) => {
        this.loading = false;
        this.tempTableData = result.results;
        this.tableData = this.tempTableData.map(resultData => {
          resultData.action_display = 'HISTORY.ACTION-ENUM.' + resultData.action_display;
          resultData.address_display = 'HISTORY.ADDRESS-ENUM.' + resultData.address_display;
          return resultData;
        });
        this.no_data = _.isEmpty(this.tempTableData);
        if (result) {
          this.totalItems = result.count;
        }
        return this.tempTableData;
      },
      error => {
        this.loading = false;
        this.no_data = true;
        this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.deliverycode) && this.allDeliverycode === false) {
      errorMsgList.push(this.translate.instant('FILTER.DELIVERY-CODE'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY')
        + ' ' + errorMsgList.join(', ')
        + ' ' + this.translate.instant('COMMON.CORRECT');
      return;
    }
  }

  clearData() {
    this.clearSearch();
    this.tableData = undefined;
    this.no_data = true;
    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();
    this.selectedCustomercode = null;
    this.selectedDeliverycode = null;
    this.selectedRdDocumentType = null;
    this.deliverycode = null;
    this.documentType = null;
    this.notApprove = false;
    this.allDocType = true;
    this.allDeliverycode = true;
    this.sortBy = null;
    this.sortMode = null;
    this.selectedValues = [];
    this.searchButtonClicked();
  }

  pageChanged() {
    let params = new HttpParams();
    params = params.append('page', this.currentPage.toString());
    this.searchData(params);
  }

  DownloadReport() {
    this.loading_excel_report = true;
    const params = {
      actor_id: this.searchUsername,
      role_id: this.searchRole,
      action: this.searchAction,
      start_date: moment(this.startDate).format('YYYY-MM-DD'),
      end_date: moment(this.endDate).format('YYYY-MM-DD')
    };
    this.apiService.getActionsLogExcelReport(params).subscribe(
      (obj) => {
        const filename = 'actions_log_report' + '.xlsx';
        this.apiService.createDownloadFile(obj, filename);
        this.loading_excel_report = false;
        this.sniff('DOWNLOAD_XLS', filename);
      },
      error => {
        this.loading_excel_report = false;
      }
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'ACTIONS_LOG',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log.component.ts